const CITIES = [
  "Agra", "Ahmedabad", "Amritsar", "Aurangabad", "Bangalore",
  "Bhopal", "Bhubaneswar", "Chandigarh", "Chennai", "Coimbatore",
  "Delhi", "Dehradun", "Faridabad", "Gurgaon", "Guwahati",
  "Hyderabad", "Indore", "Jaipur", "Jamshedpur", "Jodhpur",
  "Kochi", "Kolkata", "Lucknow", "Ludhiana", "Mangalore",
  "Mumbai", "Mysore", "Nagpur", "Nashik", "Noida",
  "Patna", "Pune", "Rajkot", "Ranchi", "Surat",
  "Thiruvananthapuram", "Udaipur", "Vadodara", "Varanasi", "Visakhapatnam"
];

export default CITIES;
